import initState from "./state";
export default {
  SET_STATE_RESET(state) {
    Object.assign(state, initState);
  },
  SET_ORDERS(state, orders) {
    state.orders = orders;
  },
};
